import { HeroUIProvider, ToastProvider } from '@cavela/ui';

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <HeroUIProvider>
      <ToastProvider toastOffset={4} placement="bottom-left" />
      {children}
    </HeroUIProvider>
  );
};

export default ThemeProvider;
